import React from 'react';

export const NotFound = () => (
  <div>
    <p>Error: Page does not exist!</p>
  </div>
);
